import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCodeEditorComponent from 'webapp/components/form/code-editor';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';

interface Args {
	form: CustomMetricSetupFormApiMetricBuilder;
	isDisabled: boolean;
	theme: string;
	onContentChange: () => void;
}

export default class CustomQuerySetupApiMetricBuilderBodyComponent extends Component<Args> {
	get bodyString(): string {
		return this.args.form.body ? JSON.stringify(this.args.form.body, null, '\t') : '';
	}

	@action
	onValidChange(isValid: boolean): void {
		this.args.form.isBodyValid = isValid;
	}

	@action
	onTextChange(text: string): void {
		if (text) {
			try {
				const json = JSON.parse(text);
				this.args.form.body = json;
			} catch (_e) {
				return;
			}
		} else {
			// empty is valid
			this.args.form.body = null;
		}
	}
	<template>
		<FormCodeEditorComponent
			@text={{this.bodyString}}
			@mode="json"
			@isReadOnly={{@isDisabled}}
			@onTextChange={{this.onTextChange}}
			@onValidChange={{this.onValidChange}}
			@theme={{@theme}}
		/>
	</template>
}
